import request from '../utils/request';
import axios from 'axios'

export const ChatAPI = {
    /**
     * 查询场景列表
     */
    querySceneList() {
        return request({
            url: "/api/chat/scenes",
            method: "get"
        })
    },
    /**
     * 查询场景详情
     * @param {string} keyword 场景关键字
     */
    querySceneDetail(keyword) {
        return request({
            url: "/api/chat/scenes/" + keyword,
            method: "get"
        })
    },
    /**
     * 查询标签组
     * @param {string} keyword 场景关键字
     */
    queryTagGroup(keyword) {
        return request({
            url: "/api/chat/tags",
            method: "get",
            params: { "keyword": keyword }
        })
    },
    /**
     * 对话
     * @param {object} data 聊天数据
     */
    chat(data) {
        return request({
            url: "/api/chat",
            method: "post",
            data
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/chat.js